// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function ResellerNonProfitDiscountRow() {
   const state = useQuoteContext()
   const { getFormattedString } = state

   if (state.resellerCustomerQuoteValues.nonProfitDiscountAmount > 0)
      return (
         <div className='row'>
            <div className='col-bhr1 col-bhr5'>
               {getFormattedString(
                  'product.ResellerNonProfitDiscountRow.Title',
                  {
                     discountAmount:
                        state.discount_list['nonProfit']['DiscountAmount'],
                  },
               )}
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col col-bhr-red'>
               {formatFloatAsCurrencySymbol(
                  state.resellerCustomerQuoteValues.nonProfitDiscountAmount,
                  state.currencyObject,
               )}
            </div>
         </div>
      )
}
